export const BODY_PROP = "isBody";
export const DETAIL_MIN_WIDTH = 550;
export const DIRECTION = {
  RTL: 'rtl',
  LTR: 'ltr'
};
export const MASTER_WIDTH = 600;
export const MASTER_MIN_WIDTH = 400;
export const RESPONSIVE_MODE = {
  EXTRA_LARGE_DESKTOP: {
    key: 'xxdt',
    value: 1920
  },
  LARGE_DESKTOP: {
    key: 'xdt',
    value: 1600
  },
  DESKTOP: {
    key: 'dt',
    value: 1200
  },
  MINI_DESKTOP: {
    key: 'mdt',
    value: 960
  }
};
